// Where n2p-ui-library (9.x) resolves the images its JS loads: the folder that contains
// `n2p-lib-assets/`, which vite.config.ts copies next to `index.html`. Without it the library falls
// back to the prod CDN, so `src/preload.tsx` imports this module first, before any library chunk
// can evaluate.
window.N2P_UI_LIBRARY_PUBLIC_PATH = import.meta.env.BASE_URL;
